<template>
  <v-card v-bind="$attrs">
    <template v-if="showMedia">
      <!-- Carousel -->
      <v-carousel
        :key="carouselKey"
        v-model="carousel"
        continuous
        height="auto"
      >
        <v-carousel-item
          v-for="item in internalMedia"
          :key="item.id"
          :value="item.id"
          @click="photoswipe = item.id"
        >
          <!-- image -->
          <template v-if="item.type === 'image'">
            <v-img :src="item.src" :aspect-ratio="4 / 3" />
          </template>
          <!-- type not supported -->
          <template v-else>
            {{ $t('fresh-vue.misc.error') }}
          </template>
        </v-carousel-item>
      </v-carousel>

      <!-- Overview -->
      <draggable
        :list="internalMedia"
        handle=".draghandle"
        class="preview mt-2"
        tag="v-row"
        :component-data="{ props: { dense: true } }"
        @change="onChange"
      >
        <v-col
          v-for="item in internalMedia"
          :key="item.id"
          cols="12"
          md="6"
          lg="4"
          class="preview-item"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              outlined
              :class="{
                'elevation-4': hover,
                selected: carousel === item.id
              }"
              @click="carousel = item.id"
            >
              <!-- image -->
              <template v-if="item.type === 'image'">
                <v-img :src="item.src" :aspect-ratio="16 / 9">
                  <div
                    v-if="sortable || deletable"
                    class="preview-item-actions pa-1 white--text"
                  >
                    <v-row no-gutters>
                      <v-col cols="6" class="text-left">
                        <v-icon
                          v-if="sortable"
                          color="white"
                          class="draghandle"
                        >
                          $freshvue-drag
                        </v-icon>
                      </v-col>
                      <v-col cols="6" class="text-right">
                        <slot name="actions" :item="item" />
                        <v-tooltip v-if="deletable" left>
                          <template #activator="{ on }">
                            <v-icon
                              color="error"
                              v-on="on"
                              @click="onDelete(item)"
                            >
                              $freshvue-delete
                            </v-icon>
                          </template>

                          {{ $t('fresh-vue.misc.delete') }}
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                </v-img>
              </template>
              <!-- type not supported -->
              <template v-else>
                {{ $t('fresh-vue.misc.error') }}
              </template>
            </v-card>
          </v-hover>
        </v-col>
      </draggable>

      <!-- photoswipe -->
      <gallery-photoswipe v-model="photoswipe" :images="internalMedia" />
    </template>
    <v-row v-else>
      <v-col cols="12" class="text-center">
        <template v-if="$slots.nodata">
          <slot name="nodata" />
        </template>
        <template v-else>
          <v-alert type="info" text class="mb-0">
            {{ $t('fresh-vue.Gallery.no-data') }}
          </v-alert>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import AlertUtils from '../utils/alert.js'

import draggable from 'vuedraggable'
import GalleryPhotoswipe from './GalleryPhotoswipe'

export default {
  name: 'Gallery',

  components: {
    draggable,
    GalleryPhotoswipe
  },

  props: {
    media: {
      type: Array,
      required: false,
      default: () => []
    },

    sortable: {
      type: Boolean,
      required: false,
      default: false
    },

    deletable: {
      type: Boolean,
      required: false,
      default: false
    },

    doNotRemoveFromInternalCache: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      carousel: null,
      photoswipe: null,

      internalMedia: []
    }
  },

  computed: {
    showMedia() {
      return this.internalMedia.length > 0
    },

    /**
     * The v-carousel won't update if the internalMedia is changed (I don't know why...),
     * so we will just use a key for the v-carousel to force it to update.
     */
    carouselKey() {
      return this.internalMedia.map((item) => item.id).join('-')
    }
  },

  watch: {
    media: {
      handler: function (media, previous) {
        if (!_.isEqual(media, previous)) {
          this.internalMedia = (media || [])
            // .filter(item => item.type === 'image')
            .map((item) => ({
              id: uuidv4(),
              ...item
            }))
        }
      },
      immediate: true
    }
  },

  methods: {
    onDelete(item) {
      AlertUtils.fireQuestion({
        text: this.$t('fresh-vue.Gallery.delete-confirmation')
      }).then((result) => {
        if (result.value) {
          if (!this.doNotRemoveFromInternalCache) {
            const index = this.internalMedia.findIndex((i) => i.id === item.id)
            this.internalMedia.splice(index, 1)
          }

          this.$emit('delete', item)
        }
      })
    },

    onChange(data) {
      if (data.moved) {
        this.$emit('move', {
          item: data.moved.element,
          newIndex: data.moved.newIndex,
          oldIndex: data.moved.oldIndex
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.selected {
  border-color: var(--v-primary-base) !important;
}

.v-carousel::v-deep .v-carousel__item {
  cursor: pointer;
}

.preview::v-deep {
  // --preview-gap: 10px;
  // --preview-columns: 3;

  // display: flex;
  // flex-wrap: wrap;
  // gap: var(--preview-gap);

  .preview-item {
    // flex: 0 1
    //   calc(
    //     100% / var(--preview-columns) - var(--preview-gap) /
    //       var(--preview-columns) * (var(--preview-columns) -1)
    //   );

    .preview-item-actions {
      background-color: rgba(0, 0, 0, 0.25);

      .draghandle {
        cursor: move;
      }
    }
  }
}
</style>
